import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AdminService } from '../services/admin.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  standalone: false
})
export class DashboardComponent implements OnInit {
  stats$: Observable<any>;
  loading = true;
  
  constructor(
    public adminService: AdminService,
    private router: Router
  ) {
    this.stats$ = this.adminService.getDeletionStats();
  }

  ngOnInit(): void {
    // Vérifier les droits d'administration
    if (!this.adminService.isAdmin()) {
      this.router.navigate(['/admin/login']);
    } else {
      this.loading = false;
    }
  }

  logout(): void {
    this.adminService.adminLogout().then(() => {
      this.router.navigate(['/admin/login']);
    });
  }

  navigateToDeletionRequests(): void {
    this.router.navigate(['/admin/account-deletion-requests']);
  }
}
